<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İsim</label>
            <v-select-list :options="names" v-model="name" label="Value" placeholder="İsim"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Kategori</label>
            <v-select-list :options="categories" v-model="category" label="Value" placeholder="Kategori"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Eğitim Saati</label>
            <input type="number" class="form-control" placeholder="Eğitim Saati" v-model="value.EducationHours"/>
        </div>
        <div class="col-12">
            <label class="form-label">Yenileme Süresi (Yıl)</label>
            <input type="number" class="form-control" placeholder="Yenileme Süresi (Yıl)" v-model="value.RenewalPeriodYears"/>
        </div>
    </div>
</template>

<script>
import HazardApi from '@/api/hazard-class'

export default{
    props:{
        value:Object
    },
    data(){
        return {
            names:[],
            categories:[]
        }
    },
    mounted(){
        this.getCategories()
        this.getNames()
    },
    methods:{
        getCategories(){
            HazardApi.CategoryList().then(res => {
                this.categories = res.data.Data
            })
        },
        getNames(){
            HazardApi.NameList().then(res => {
                this.names = res.data.Data
            })
        }
    },
    computed:{
        name:{
            get:function(){
                return this.names.find(b=>Number(b.Key)==this.value.Name)
            },
            set:function(value){
                this.value.Name = Number(value?.Key) >= 0 ? Number(value?.Key) : null
            }
        },
        category:{
            get:function(){
                return this.categories.find(b=>Number(b.Key)==this.value.Category)
            },
            set:function(value){
                this.value.Category = Number(value?.Key) >= 0 ? Number(value?.Key) : null
            }
        }
    }
}
</script>